import React from 'react';
import { Link } from 'react-router-dom';

const differentiators = [
  {
    title: 'Fish + Goat in one platform',
    desc: 'No other platform handles both. NavFarm, KisanAqua, GoatMate — all separate. FarmLog does both.',
  },
  {
    title: 'Built by a farmer',
    desc: 'Not a software company guessing what farmers need. Built by someone who runs a 5-acre fish farm and 50-goat herd.',
  },
  {
    title: '10x more affordable',
    desc: 'International tools cost Rs5,000+/month. FarmLog is Rs500/month — less than one bag of feed.',
  },
  {
    title: 'Simple, not ERP',
    desc: 'No complex setup. No consultant needed. Open the web app, start logging. If you use WhatsApp, you can use FarmLog.',
  },
];

const Trust: React.FC = () => {
  return (
    <section className="py-20 bg-slate-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Why different */}
        <div className="text-center max-w-2xl mx-auto">
          <h2 className="text-2xl font-bold text-slate-900 sm:text-3xl">
            Why farmers choose FarmLog
          </h2>
          <p className="mt-3 text-slate-600 text-lg">
            We are not just another farm software. Here is what makes us different.
          </p>
        </div>
        <div className="mt-12 grid gap-6 sm:grid-cols-2">
          {differentiators.map((d, i) => (
            <div key={i} className="flex items-start gap-4 p-6 rounded-2xl bg-white border border-slate-200 shadow-sm hover:shadow-md transition">
              <div className="flex-shrink-0 w-10 h-10 rounded-xl bg-amber-500 text-slate-900 flex items-center justify-center text-lg font-bold">
                {i + 1}
              </div>
              <div>
                <h3 className="font-semibold text-slate-900">{d.title}</h3>
                <p className="mt-1 text-slate-600 text-sm leading-relaxed">{d.desc}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Social proof */}
        <div className="mt-16 rounded-2xl bg-white p-8 border border-slate-200 shadow-sm">
          <div className="text-center">
            <p className="text-slate-500 text-sm uppercase tracking-wider font-medium mb-6">Trusted by real farmers</p>
          </div>
          <div className="grid gap-8 sm:grid-cols-3 max-w-5xl mx-auto">
            <div className="bg-slate-50 rounded-xl p-5 border border-slate-100 flex flex-col justify-between">
              <p className="text-slate-700 text-sm italic leading-relaxed">
                "I was keeping track of everything in a notebook. Some pages got wet, I lost data. With FarmLog, everything is on my phone now. I can see my pond expenses clearly."
              </p>
              <div className="mt-4 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-blue-100 flex items-center justify-center text-blue-700 text-sm font-bold">S</div>
                <div>
                  <p className="text-sm font-medium text-slate-900">Srikant Raju, Fish Farmer</p>
                  <p className="text-xs text-slate-500">East Godavari, AP</p>
                </div>
              </div>
            </div>
            <div className="bg-slate-50 rounded-xl p-5 border border-slate-100 flex flex-col justify-between">
              <p className="text-slate-700 text-sm italic leading-relaxed">
                "Managing feed costs across multiple ponds used to be a headache. FarmLog makes it incredibly simple to track daily feed, mortality, and expenses. Now we know our exact profit margins before harvest!"
              </p>
              <div className="mt-4 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-emerald-100 flex items-center justify-center text-emerald-700 text-sm font-bold">L</div>
                <div>
                  <p className="text-sm font-medium text-slate-900">Lilawati Fish Farm</p>
                  <p className="text-xs text-slate-500">Badhya Farm Nichlaul, UP</p>
                </div>
              </div>
            </div>
            <div className="bg-slate-50 rounded-xl p-5 border border-slate-100 flex flex-col justify-between">
              <p className="text-slate-700 text-sm italic leading-relaxed">
                "The goat breeding tracker is very useful. I know exactly when each goat was mated and when kidding is expected. No more guessing."
              </p>
              <div className="mt-4 flex items-center gap-3">
                <div className="w-9 h-9 rounded-full bg-orange-100 flex items-center justify-center text-orange-700 text-sm font-bold">D</div>
                <div>
                  <p className="text-sm font-medium text-slate-900">Debashis Roy, Goat Farmer</p>
                  <p className="text-xs text-slate-500">Bankura, West Bengal</p>
                </div>
              </div>
            </div>
          </div>
          <p className="text-center mt-6 text-slate-500 text-sm">
            Join successful farmers across India using FarmLog for their fish and goat operations.
          </p>
        </div>

        {/* CTA */}
        <div className="mt-10 text-center">
          <Link
            to="/demo"
            className="inline-flex items-center gap-2 rounded-xl bg-amber-500 px-7 py-3.5 text-base font-bold text-slate-900 hover:bg-amber-400 transition shadow-md shadow-amber-500/20"
          >
            See Demo
          </Link>
        </div>
      </div>
    </section>
  );
};

export default Trust;
